import React from "react";
import { useTranslation } from "react-i18next";
import "./PerfumeCustomization.css";

export default function PerfumeCustomization({
  value,
  onChange,
  maxLen = 40,
  error,
}) {
  const { t } = useTranslation();
  const enabled = value?.enabled; // null, true veya false olabilir
  const text = value?.text ?? "";

  return (
    <div className="mt-3 perfume-customization">
      <p className="fw-14 fw-500 mb-2">{t("customization.question")}</p>

      <div className="d-flex gap-3">
        <label className="d-flex align-items-center gap-2">
          <input
            type="radio"
            name="customization"
            checked={enabled === true}
            onChange={() => onChange({ enabled: true, text })}
          />
          {t("customization.yes")}
        </label>

        <label className="d-flex align-items-center gap-2">
          <input
            type="radio"
            name="customization"
            checked={enabled === false}
            onChange={() => onChange({ enabled: false, text: "" })}
          />
          {t("customization.no")}
        </label>
      </div>

      {/* Hata mesajı */}
      {error && <small className="text-danger d-block mt-1">{error}</small>}

      {enabled && (
        <div className="mt-2">
          <input
            className="form-control text-lowercase"
            placeholder={t("customization.placeholder")}
            value={text}
            onChange={(e) => onChange({ enabled: true, text: e.target.value })}
            maxLength={maxLen}
          />
          <small className="text-muted">
            {text.length}/{maxLen}
          </small>
        </div>
      )}
    </div>
  );
}
